import {useEffect, useState} from 'react';
import {useBehaviorSubject} from '@esgi/ui/utils';
import {Form} from '@esgi/ui/form';
import {useService} from '@esgi/core/service';
import {Reports} from '@esgi/main/kits/reports';
import {ParentLetterService} from './service';
import {Content, RightSidebar} from '../../layout/index.styled';
import {ParentLetterPage} from './index.styled';
import {studentsMock, gradeRangesMock} from './test-mocks';
import {withNewOldReports} from '../../old-reports';
import {OldParentLetterReport} from '../../old-reports/students/parent-letter';

function ParentLetter() {

	const service = useService(ParentLetterService);
	const isSubjectsDataLoaded = useBehaviorSubject(service.isSubjectsDataLoaded);
	const tests = useBehaviorSubject(service.tests$);
	const isTestDataLoaded = useBehaviorSubject(service.isTestDataLoaded);

	const selectedStudentID = useBehaviorSubject(service.selectedStudentID);
	const selectedSubject = useBehaviorSubject(service.selectedSubject);
	const selectedTestIDs = useBehaviorSubject(service.selectedTestIDs);
	const subjects = useBehaviorSubject(service.subjects);
	const [isReportButtonDisabled, setReportButtonDisabled] = useState(false);


	useEffect(() => {
		setReportButtonDisabled(!selectedTestIDs?.length);
	}, [selectedTestIDs?.length]);

	useEffect(() => {
		service.init().subscribe();
	}, []);

	const onReport = () => {
		service.report().subscribe((r) => {
			console.log('rrr', r);
		});
	};

	const onViewAndEditTemplate = () => {
		console.log('onViewAndEditTemplate');
	};

	return <ParentLetterPage justify='between'>
		<Reports.StudentLevel.SingleStudentPanel onChange={(value) => service.selectedStudentID.next(value?.studentId)}/>

		<Content>
			<Reports.Header
				student={studentsMock[0]}
				subjects={subjects}
				skeleton={!isSubjectsDataLoaded}
				onChangeSubject={(value) => service.selectedSubject.next(subjects.find(s => s.id.toString() === value))}
				selectedSubject={selectedSubject}
			/>
			<Reports.TestsControl
				withExpandableListItem
				tests={tests}
				onChange={(value) => service.selectedTestIDs.next(value)}
				skeleton={!isTestDataLoaded}
				onChangeTestsData={(testID, session) => service.updateTestCardsData(testID, session)}
				selectedStudentID={selectedStudentID}
			/>
		</Content>

		<RightSidebar>
			<Form controller={service.form}>
				<Reports.ReportPanel
					reportTitle='Report'
					onReport={onReport}
					disabled={isReportButtonDisabled}
				/>

				<Reports.SettingsControl
					includeSkippedQuestionsControl={service.form.controls.isIncludeSkippedQuestions}
					showNotesControl={service.form.controls.isShowNotes}
					showSessionDateControl={service.form.controls.isShowSessionDate}
					showSummaryControl={service.form.controls.isShowSummary}
				/>

				<Reports.GradesControl
					includeGradesControl={service.form.controls.isIncludeGrades}
					gradeRanges={gradeRangesMock}
				/>

				<Reports.LetterTemplateControl
					includeParentMessage={service.form.controls.isIncludeParentMessage}
					onViewAndEditTemplate={onViewAndEditTemplate}
				/>
			</Form>
		</RightSidebar>
	</ParentLetterPage>;
}

export default withNewOldReports(OldParentLetterReport, ParentLetter);